import React from 'react'
import { css } from 'styled-components'
import { Box } from 'rebass'

export const ColorOverlay = () => (
  <Box
    bg="red"
    css={css`
      opacity: 0.8;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      content: '';
      z-index: 0;
    `}
  />
)
